import { useMutation } from 'react-query';

import {
    QueryParams,
    QueryResponse,
    setShowPredictionLikelihood,
} from 'api/endPoints/setShowPredictionLikelihoodForProject';

export const useMutationSetProjectIsShowPredictionLikelihood = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>({
        mutationFn: (params: QueryParams) => setShowPredictionLikelihood(params),
    });
};
